<template>
	<div class="locks">
		<div class="header">
			<img src="/nw-logo.png" />
		</div>
		<div class="buttons">
			<div class="button" :class="{ loading: isLoading }">
				<i class="fad fa-door-open" v-if="!isSuccess && !hasError" @click="unlockLock"></i>
				<div class="spinner" v-if="isLoading"></div>
				<i class="fad fa-check" v-if="isSuccess"></i>
				<i class="fad fa-exclamation" v-if="hasError"></i>
			</div>
			<span v-if="!isLoading && !isSuccess && !hasError">Eingangstür öffnen</span>
			<span class="error" v-if="hasError">{{ errorMessage }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "locks",
		mixins: [],
		components: {
		},
		data() {
			return {
				isLoading: false,
				isSuccess: false,
				hasError: false,
				errorMessage: null
			}
		},
		methods: {
			unlockLock() {
				//
				const request = {
					method: "POST",
					headers: {
						"CSRF-Token": this.getCookie("XSRF-TOKEN"),
						"Content-Type": "application/json"
					},
					body: JSON.stringify({
						token: this.$route.params.token
					})
				};

				//
				const staging = ["1", "true"].includes(this.$route.query.staging);
				let url = `/api/locks/${this.$route.params.directory}/unlock`;
				if (staging) { url += "?staging=true" }

				//
				if (this.isLoading) return;
				this.isLoading = true;
				fetch(url, request).then(response => {
					response.json().then(result => {
						this.isLoading = false;
						if (result && result.toString() === "true") {
							this.isSuccess = true;
							this.hasError = false;
							this.errorMessage = null;
							window.setTimeout(() => this.isSuccess = false, 4000);
						}
						else {
							this.isSuccess = false;
							this.hasError = true;
							this.errorMessage = result || "unspecified error";
							window.setTimeout(() => this.hasError = false, 6000);
						}
					});
				});
			},
			getCookie(name) {
				var match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
				return match ? match[2] : null;
			}
		}
	}
</script>